export default __webpack_public_path__ + "static/media/RTC_UploadTemplate.5868902c.xlsx";